import {
  Alert,
  Button,
  Divider,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { HEADER_HEIGHT } from "src/dashboard/components/ExpandSideMenuButton";
import { OrganisationUserList } from "./organisationUserList";
import { AddOrganisationUser } from "./addOrganisationUser";

export const ManageOrganisationUsers = () => {
  const { t } = useTranslation();
  const { organisationName } = useParams<{ organisationName: string }>();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const groupName = organisationName!;

  const [addUserModalOpen, setAddUserModalOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleOnError = (message: string) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMessage("");
  };

  return (
    <Stack sx={{ height: "100%" }}>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          justifyContent: "space-between",
          px: 2,
          height: HEADER_HEIGHT,
        }}
      >
        <Typography variant="h4" component="h1">
          {t("manageUsers")}
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            setAddUserModalOpen(true);
          }}
          sx={{ minWidth: 130 }}
        >
          {t("addOrganisationUser")}
        </Button>
      </Stack>
      <Divider />
      <Stack
        sx={{
          flex: 1,
          maxHeight: "100%",
          overflow: "auto",
        }}
      >
        <Stack sx={{ mx: 2 }}>
          <OrganisationUserList groupName={groupName} onError={handleOnError} />
          <AddOrganisationUser
            groupName={groupName}
            isOpen={addUserModalOpen}
            onClose={() => {
              setAddUserModalOpen(false);
            }}
            onError={handleOnError}
          />
        </Stack>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <Alert severity="error">{snackbarMessage}</Alert>
        </Snackbar>
      </Stack>
    </Stack>
  );
};
